export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    MARKET_ADMIN_ALL: function MARKET_ADMIN_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/market-admin/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    MARKET_ADMIN_CREATE: function MARKET_ADMIN_CREATE(data) {
      return request({
        url: '/api/market-admin/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_ADMIN_DETAIL: function MARKET_ADMIN_DETAIL(id) {
      return request({
        url: '/api/market-admin/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_ADMIN_UPDATE: function MARKET_ADMIN_UPDATE(data) {
      return request({
        url: '/api/market-admin/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    MARKET_ADMIN_DELETE: function MARKET_ADMIN_DELETE(id) {
      return request({
        url: '/api/market-admin/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    MARKET_ADMIN_SYNC: function MARKET_ADMIN_SYNC(data) {
      return request({
        url: '/api/market-admin/sync',
        method: 'post',
        data: data
      });
    }
  };
});